import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import { Accordion as AccordionComponent } from "../../../sharedComponents/Accordion";
import { renderCardComponent, Card } from "./renderCardComopnent";
import * as styles from "./Accordion.module.scss";

const Accordion = ({ activeKey, children, variant }) => (
	<AccordionComponent activeKey={activeKey} className={classNames(styles[`${variant}Accordion`])}>
		{React.Children.map(children, child => renderCardComponent(child, variant))}
	</AccordionComponent>
);

Accordion.defaultProps = {
	activeKey: "",
	variant: "tide",
};

Accordion.propTypes = {
	children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
	activeKey: PropTypes.string,
	variant: PropTypes.oneOf(["tide", "tideLight", "weddings", "hotels", "merch"]),
};

export default Accordion;
export { Accordion, Card };
